import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import '@valwin/facto/styles/fonts.css';
import '@valwin/facto/styles/global.css';

import { clearAllTenantsRevisions } from '~shared/api';
import '~shared/i18n/setup';

import { App } from './app/App';

import './app/styles/global.css';

clearAllTenantsRevisions();

createRoot(document.querySelector('#root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
